import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { RedirectMerchSuccessPage } from '../action-creators';
import { REDIRECT_MERCH_SUCCESS_PAGE } from '../actions';
import { push } from 'connected-react-router';

export const redirectMerchSuccessPageEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, RedirectMerchSuccessPage>(REDIRECT_MERCH_SUCCESS_PAGE),
    map((action) => {
      return push(
        `/catalog?type=merch&productId=${action.productId}`
      );
    })
  );
